import { Link } from 'react-router-dom';

const stats = [
  { value: "5000+", label: "累计独家爆料", suffix: "" },
  { value: "100", label: "万+ 日活跃用户", suffix: "" },
  { value: "99.7", label: "% 内容真实率", suffix: "%" },
  { value: "200+", label: "合作信源渠道", suffix: "" },
];

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20" style={{ backgroundColor: "oklch(0.97 0.02 75)" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="text-xs font-medium text-foreground-400 tracking-wider uppercase">About Us</span>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mt-3 mb-6">
              全网最活跃的免费吃瓜社区
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              51吃瓜爆料网成立于2020年，专注于网红黑料大全、明星翻车与热点事件深度揭秘。
              我们拥有一支专业的调查团队和广泛的信息网络，致力于为用户提供最新、最全、最真实的吃瓜资讯。
              平台始终坚持免费运营理念，让每一位吃瓜群众都能第一时间获取独家爆料。
            </p>
            <Link to="/about" className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer">
              了解更多关于我们 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, idx) => (
              <div key={idx} className="text-center p-4">
                <div className="text-4xl md:text-5xl font-black font-heading text-foreground-900 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}